import type { ReactNode } from 'react'
import { CloseButton } from './CloseButton'

/** Full-height centered layout wrapper used by the white-card screens.
 * Pass `onClose` to show the discreet ✕ (abandon session) in the card's top-right. */
export function Screen({ children, onClose }: { children: ReactNode; onClose?: () => void }) {
  return (
    <div className="flex min-h-full items-center justify-center bg-slate-100 p-4">
      <div className="relative w-full max-w-md rounded-2xl bg-white p-6 shadow-lg">
        <CloseButton onClick={onClose} tone="dark" />
        {children}
      </div>
    </div>
  )
}
